// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__UDbMS","item":"Dashboard_item__R9QhD","alert":"Dashboard_alert__iMQvc","loading":"Dashboard_loading__mQ-Bu"};